module.exports = __webpack_public_path__ + "img/edit_square.442a2cc7.svg";